import React from 'react';

// Components //
import TitleSection from "../../molecules/title-section";
import CardRates from '../../molecules/card-rates/cardRates';
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles
import "./PlansAndRates.scss";

const PlansAndRates = (props: ReferenciaContenido) => {

    const {tituloGeneral, descripcion, referenciaPlantillaContenido: ratesList} = props;


    return (
        <div className="o-PlansAndRates">
            <div className="container">
                <div className="o-PlansAndRates__inner">
                    <TitleSection title={tituloGeneral}/>
                    <div className="o-PlansAndRates__items">
                        {ratesList.map((item) => (
                            <CardRates
                                key={item.titulo}
                                tituloBanner={item.tituloBanner}
                                descripcion={item.descripcion}
                                imagenPrincipal={item.imagenPrincipal}
                                tituloDescripcion={item.tituloDescripcion}
                                tituloBoton={item.tituloBoton}
                                redireccionBoton={item.redireccionBoton}
                            />
                        ))}
                    </div>
                    <div className="o-PlansAndRates__description">
                        {descripcion && (
                            <div className="o-PlansAndRates__description__text">
                                {contentfulRenderOptions(descripcion.json)}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PlansAndRates;
